import React from 'react';
import { useBuildComponentTypes } from '../../../../../contexts/BuildComponentTypesContext';
import { maintenanceTemplateApi } from '../../../../../api/maintenanceTemplateApi';
import { TemplateCostFormModal } from './shared';
import { CostUnit } from '../../../../Förvaltning/TemplatesEditor/types';
import { LibraryPickerModal } from '../../../../../Components/LibraryPickerModal';
import { maintenanceLibrary } from '../../../../../library/maintenanceLibrary';

interface EditTemplateActivityCostModalProps {
    componentType: string;
    componentTypeName: string;
    templateId: string;
    templateName: string;
    currentCost: number;
    currentCostUnit: CostUnit;
    buildingKey: string;
    onClose: () => void;
}

/**
 * Modal for editing the maintenance activity template's base cost.
 * Warning: Changes affect ALL components of this type using this activity.
 *
 * Requires admin privileges.
 */
export const EditTemplateActivityCostModal: React.FC<EditTemplateActivityCostModalProps> = ({
    componentType,
    componentTypeName,
    templateId,
    templateName,
    currentCost,
    currentCostUnit,
    buildingKey,
    onClose
}) => {
    const { refresh, getBaseType } = useBuildComponentTypes();

    const handleSave = async (cost: number, costUnit: CostUnit) => {
        await maintenanceTemplateApi.updateActivityTemplateCost(
            componentType,
            templateId,
            cost,
            costUnit,
            { source: 'draft', buildingKey }
        );

        // Refresh the component types context; the plan follows the context
        await refresh();
    };

    return (
        <TemplateCostFormModal
            title={`Ändra mallkostnad - ${templateName}`}
            warningMessage={
                <>
                    <strong>Obs!</strong> Ändringar här påverkar <strong>alla komponenter</strong> av typen "{componentTypeName}" som använder denna aktivitet med mallkostnad. Komponenter med anpassad schablon eller kostnad enligt offert påverkas inte.
                </>
            }
            costLabel="Kostnad"
            currentCost={currentCost}
            currentCostUnit={currentCostUnit}
            renderLibraryPicker={({ open, onClose: onPickerClose, onPick }) => (
                <LibraryPickerModal
                    config={maintenanceLibrary}
                    open={open}
                    onClose={onPickerClose}
                    onSelect={(libTemplate) => onPick(libTemplate.cost, libTemplate.cost_unit)}
                    currentBaseType={getBaseType(componentType)}
                />
            )}
            onSave={handleSave}
            onClose={onClose}
        />
    );
};
